/**
 * Configuration centrale du site ZEVA.
 *
 * Toutes les informations « métier » (liens de prise de rendez-vous, réseaux
 * sociaux, coordonnées du cabinet, chemins d'images partagés) sont regroupées
 * ici afin d'éviter la duplication entre les composants et de faciliter la
 * maintenance : une seule source de vérité.
 */

/** Praticienne */
export const PRACTITIONER = {
  name: "Nawel BOUCHOUKH",
  title: "Psychologue clinicienne",
  subtitle: "Thérapies Cognitives et Comportementales",
} as const;

/** Coordonnées du cabinet */
export const OFFICE = {
  addressLine: "13 rue Chevreul, 94700 Maisons-Alfort",
  streetAddress: "13 rue Chevreul",
  postalCode: "94700",
  city: "Maisons-Alfort",
  region: "Île-de-France",
  country: "FR",
} as const;

/**
 * Prise de rendez-vous.
 * La téléconsultation ET le présentiel se font désormais exclusivement via
 * Doctolib (Google Meet / Google Agenda supprimés).
 */
export const BOOKING = {
  doctolib: "https://www.doctolib.fr/psychologue/cergy/nawel-bouchoukh",
} as const;

/** Réseaux sociaux et contacts directs */
export const SOCIALS = {
  linkedin: "https://www.linkedin.com/in/nawel-bouchoukh-900bab1a9/",
  facebook: "https://www.facebook.com/profile.php?id=61573640634278&sk=about",
  instagram: "https://www.instagram.com/nawel_bouchoukh_zeva_psy/",
  whatsapp: "https://wa.me/33695412116",
} as const;

/** Chemins d'images partagés (dossier public/) */
export const IMAGES = {
  logo: "/Images/logos/logo-zeva.png",
  logoRound: "/Images/logos/logo-zeva-rond.png",
  doctolib: "/Images/logos/doctolib.png",
  face: "/Images/face/photo-nawel-bouchoukh.png",
  /** Carte de visite — recto (visible) et verso (au survol / flip) */
  visitCardFront: "/Images/infos/visit-card-recto.png",
  visitCardBack: "/Images/infos/visit-card-verso.png",
} as const;

/**
 * Configuration EmailJS (formulaire de contact).
 * Les identifiants proviennent des variables d'environnement REACT_APP_*.
 * Note : la clé publique EmailJS est, par conception, exposée côté client ;
 * la protection anti-spam se fait via honeypot + limitation de débit.
 */
export const EMAILJS = {
  serviceId: process.env.REACT_APP_MAIL_SERVICE_ID || "",
  templateId: process.env.REACT_APP_MAIL_TEMPLATE_ID || "",
  userId: process.env.REACT_APP_MAIL_USER_ID || "",
} as const;
